const map = {
	"./chat/cn/app.json": "./webpack-assets/vue/messages/chat/cn/app.json",
	"./chat/de/app.json": "./webpack-assets/vue/messages/chat/de/app.json",
	"./chat/en/app.json": "./webpack-assets/vue/messages/chat/en/app.json",
	"./chat/es/app.json": "./webpack-assets/vue/messages/chat/es/app.json",
	"./chat/fr/app.json": "./webpack-assets/vue/messages/chat/fr/app.json",
	"./chat/it/app.json": "./webpack-assets/vue/messages/chat/it/app.json",
	"./chat/ja/app.json": "./webpack-assets/vue/messages/chat/ja/app.json",
	"./chat/ko/app.json": "./webpack-assets/vue/messages/chat/ko/app.json",
	"./chat/nl/app.json": "./webpack-assets/vue/messages/chat/nl/app.json",
	"./chat/pl/app.json": "./webpack-assets/vue/messages/chat/pl/app.json",
	"./chat/pt/app.json": "./webpack-assets/vue/messages/chat/pt/app.json",
	"./chat/ru/app.json": "./webpack-assets/vue/messages/chat/ru/app.json",
	"./common/cn/app.json": "./webpack-assets/vue/messages/common/cn/app.json",
	"./common/de/app.json": "./webpack-assets/vue/messages/common/de/app.json",
	"./common/en/app.json": "./webpack-assets/vue/messages/common/en/app.json",
	"./common/es/app.json": "./webpack-assets/vue/messages/common/es/app.json",
	"./common/fr/app.json": "./webpack-assets/vue/messages/common/fr/app.json",
	"./common/it/app.json": "./webpack-assets/vue/messages/common/it/app.json",
	"./common/ja/app.json": "./webpack-assets/vue/messages/common/ja/app.json",
	"./common/ko/app.json": "./webpack-assets/vue/messages/common/ko/app.json",
	"./common/nl/app.json": "./webpack-assets/vue/messages/common/nl/app.json",
	"./common/pl/app.json": "./webpack-assets/vue/messages/common/pl/app.json",
	"./common/pt/app.json": "./webpack-assets/vue/messages/common/pt/app.json",
	"./common/ru/app.json": "./webpack-assets/vue/messages/common/ru/app.json",
	"./product/cn/app.json": "./webpack-assets/vue/messages/product/cn/app.json",
	"./product/de/app.json": "./webpack-assets/vue/messages/product/de/app.json",
	"./product/en/app.json": "./webpack-assets/vue/messages/product/en/app.json",
	"./product/es/app.json": "./webpack-assets/vue/messages/product/es/app.json",
	"./product/fr/app.json": "./webpack-assets/vue/messages/product/fr/app.json",
	"./product/it/app.json": "./webpack-assets/vue/messages/product/it/app.json",
	"./product/ja/app.json": "./webpack-assets/vue/messages/product/ja/app.json",
	"./product/ko/app.json": "./webpack-assets/vue/messages/product/ko/app.json",
	"./product/nl/app.json": "./webpack-assets/vue/messages/product/nl/app.json",
	"./product/pl/app.json": "./webpack-assets/vue/messages/product/pl/app.json",
	"./product/pt/app.json": "./webpack-assets/vue/messages/product/pt/app.json",
	"./product/ru/app.json": "./webpack-assets/vue/messages/product/ru/app.json"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./webpack-assets/vue/messages sync recursive ^\\.\\/.*\\/.*\\/app\\.json$";